/**
 * Helpers de permisos de borrado para las galerías. Espejo en frontend
 * de las funciones `canDelete` del backend (api/src/routes/*).
 *
 * NO son la fuente de verdad — el backend siempre re-valida en cada
 * DELETE. Aquí solo se usan para decidir si pintar el botón X.
 *
 * Reglas:
 *  - Briefings: autor + admin/superadmin (Comandantes), tanto para
 *    borrar como para editar.
 *  - Debriefings: autor + superadmin para BORRAR (admin no entra). Para
 *    EDITAR solo el autor — el superadmin actúa como válvula de
 *    moderación borrando si hace falta, no reescribiendo la voz del
 *    piloto. Decisión Fase 7b actualizada 2026-05-10.
 *  - Reportes: autor (uploadedBy) + admin/superadmin.
 */

import type { AuthenticatedPilot } from '@51esc/shared';

export function canDeleteBriefing(
  user: AuthenticatedPilot,
  briefing: { userId: string },
): boolean {
  if (briefing.userId === user.id) return true;
  return user.role === 'admin' || user.role === 'superadmin';
}

export function canEditBriefing(
  user: AuthenticatedPilot,
  briefing: { userId: string },
): boolean {
  // Misma regla que el borrado: autor + admin/superadmin.
  return canDeleteBriefing(user, briefing);
}

export function canDeleteDebriefing(
  user: AuthenticatedPilot,
  debriefing: { userId: string },
): boolean {
  if (debriefing.userId === user.id) return true;
  return user.role === 'superadmin';
}

export function canEditDebriefing(
  user: AuthenticatedPilot,
  debriefing: { userId: string },
): boolean {
  // Más estricto que el borrado: solo el autor edita su debriefing.
  return debriefing.userId === user.id;
}

export function canDeleteMissionReport(
  user: AuthenticatedPilot,
  report: { uploadedByUserId: string | null },
): boolean {
  if (report.uploadedByUserId !== null && report.uploadedByUserId === user.id) {
    return true;
  }
  return user.role === 'admin' || user.role === 'superadmin';
}
